import { render } from "./GuestsReportTable.vue?vue&type=template&id=794239c5"
import script from "./GuestsReportTable.vue?vue&type=script&lang=js"
export * from "./GuestsReportTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__